export const DOMAIN = 'Status';
